import * as React from 'react';
import * as styles from './styles.scss';
import { getCanvasPanZoomBounds } from '../viewstate';
import { observer } from 'mobx-react-lite';
import useActivityPaneContext from '../hooks/useActivityPaneContext';
import TimeStreamCanvasBody from './TimeStreamCanvasBody';
import TimeStreamCanvasInterstitial from './TimeStreamCanvasInterstitial';

export default observer(function TimeStreamCanvasBodyAndPanel() {
    const { ActivityPane } = useActivityPaneContext();
    return (
        <TimeStreamCanvasInterstitial>
            <div className={styles.canvasBodyAndPanel}>
                <TimeStreamCanvasBody />
                {ActivityPane && <ActivityPane getCanvasPanZoomBounds={getCanvasPanZoomBounds} />}
            </div>
        </TimeStreamCanvasInterstitial>
    );
});
